import { z } from "zod";
//#region src/promotion.schemas.ts
/**
* Zod schemas for app-promotion wire DTOs (app release pipeline plan §A.3).
*
* Used by CP release-engine controllers to validate request bodies and by
* the DP shell when round-tripping responses for display.
*/
const RING_SCHEMA = z.enum([
	"stable",
	"beta",
	"alpha",
	"edge"
]);
const PromoteAppVersionDtoSchema = z.object({
	appId: z.string().min(1),
	fromRing: RING_SCHEMA,
	toRing: RING_SCHEMA,
	expectedAppVersion: z.string().min(1),
	note: z.string().optional()
}).strict();
const DemoteAppVersionDtoSchema = z.object({
	appId: z.string().min(1),
	ring: RING_SCHEMA,
	expectedAppVersion: z.string().min(1),
	note: z.string().optional()
}).strict();
const PromotionResponseDtoSchema = z.object({
	appId: z.string().min(1),
	ring: RING_SCHEMA,
	appVersion: z.string().min(1),
	previousAppVersion: z.string().nullable(),
	performedBy: z.string().min(1),
	performedAt: z.string().min(1)
}).strict();
//#endregion
export { DemoteAppVersionDtoSchema, PromoteAppVersionDtoSchema, PromotionResponseDtoSchema };

//# sourceMappingURL=promotion.schemas.js.map